<template>
  <div ref="couponBox">
    <div
      :class="{
        'couponBuy-container': true,
        isoverflow: isShowRedbox || isShowRulebox,
      }"
    >
      <div class="shopping-benefit" id="shopping-benefit-id">
        <div class="shopping-title-con" @click="showRule">
          <span class="shopping-title">我的购物补贴</span>
          <img
            class="shopping-title-img"
            src="../assets/cps_couponbuy/question-circle.png"
          />
        </div>
        <div class="shopping-bot">
          <div class="shopping-price-con-bene">
            <span class="shopping-price" v-if="!needScroll">{{
              baseButie
            }}</span>
            <countTo
              :startVal="0"
              :endVal="baseButie"
              class="shopping-price"
              :duration="500"
              v-if="needScroll"
            />
            <!-- <span class="shopping-price" v-if="!baseButie">0</span>
            <countTo
              :startVal="0"
              :endVal="baseButie"
              class="shopping-price"
              :duration="500"
              v-if="baseButie"
            /> -->
            <span class="shopping-unit">元</span>
          </div>
          <div class="shopping-time-con">
            <!-- <span class="shopping-time">02</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-span">后失效</span> -->
            <timeCountDown
              :endTime="endTime"
              :haveStyle="true"
              @timeOverHandle="timeOverHandle"
              v-if="endTime"
            />
          </div>
        </div>
      </div>
      <div
        class="fix-shopping-benefit"
        id="fix-shopping-benefit-id"
        v-show="isfixShow"
      >
        <div class="fix-price-con">
          <span class="fix-num-span">补贴余额(元)</span>
          <span class="fix-num" v-if="!needScroll">{{ baseButie }}</span>
          <countTo
            :startVal="0"
            :endVal="baseButie"
            :duration="500"
            class="fix-num"
            v-if="needScroll"
          />
          <!-- <span class="fix-num" v-if="!baseButie">0</span> -->
          <!-- <countTo
            :startVal="0"
            :endVal="baseButie"
            :duration="500"
            class="fix-num"
            v-if="baseButie"
          /> -->
        </div>
        <div class="fix-time-con">
          <!-- 02:00:00:00 <span class="fix-time">后失效</span> -->
          <timeCountDown
            :endTime="endTime"
            @timeOverHandle="timeOverHandle"
            v-if="endTime"
          />
        </div>
      </div>
      <loadMore :onLoadMore="loadMore" :enableLoadMore="enableLoadMore">
        <div class="shopping-list">
          <!-- <div style="text-align:center" v-if="!list.length">努力加载中...</div> -->
          <div
            class="shopping-item"
            v-for="(item, index) in list"
            :key="index"
            @click="goPinDuoDuo(item, index)"
          >
            <div class="shopping-item-img-con">
              <div
                class="shopping-rank"
                :class="{ bg2: index == 1, bg1: index == 0 }"
                v-if="index <= 9"
              >
                Top{{ index + 1 }}
              </div>
              <img
                class="shopping-have-get"
                src="../assets/cps_couponbuy/img_have_get.png"
                v-if="item.hasGet"
              />
              <img class="shopping-img" :src="item.image" />
            </div>
            <div class="shopping-item-span-con">
              <div class="shopping-span">
                <span class="shopping-brand">拼多多</span>{{ item.title }}
                <!-- <span class="shopping-item-span">I&YOU轻奢钻饰 18K金时尚经典裙子钻石项链</span> -->
              </div>
              <div class="shopping-price-con">
                <span class="price-con1"
                  >补贴价<span class="price-con2">¥</span
                  ><span class="price-con3">{{ item.integer }}</span
                  ><span class="price-con-mini" v-if="item.decimal">{{
                    item.decimal
                  }}</span></span
                >
                <span class="price-con4">¥{{ item.original_price / 100 }}</span>
              </div>
              <div class="shopping-butie-con">
                <div class="zhekou-con">
                  <div class="zhekou-span">{{ item.discount / 1000 }}折</div>
                  <img
                    class="zhekou-img"
                    src="../assets/cps_couponbuy/bg_zk.png"
                  />
                </div>
                <div class="butiejin" v-if="item.coupon_discount">
                  补贴金¥{{ item.coupon_discount / 100 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </loadMore>
    </div>
    <div class="redbox-modal" v-if="isShowRedbox">
      <redBox :isList="true" @openRedbox="openRedbox"></redBox>
      <div class="closeBox">
        <div class="dis-inline-block closeIcon" @click="hideRedbox"></div>
      </div>
    </div>
    <div class="redbox-modal rulebox-modal" v-if="isShowRulebox">
      <div class="rulebox">
        <div class="rulebox-title">活动补贴</div>
        <div class="rulebox-content">
          <div class="rulebox-content-1">
            1.购物补贴金额为0.1-300元随机出现,每个用户每天可领1次
          </div>
          <div class="rulebox-content-1">
            2.购物补贴金额可以用于抵扣购买指定页面全部商品
          </div>
          <div class="rulebox-content-1">
            3.该页面商品由拼多多提供,订单物流和售后均由拼多多提供
          </div>
          <div class="rulebox-content-1">
            4.使用流程: 点击商品 - 领取优惠券 - 进去后续详情页购买时自动抵扣
          </div>
        </div>
        <img
          class="rulebox-btn"
          src="../assets/cps_couponbuy/btn_yes.png"
          @click="hideRulebox"
        />
        <!-- <div class="rulebox-btn">我知道了</div> -->
      </div>
      <div class="closeBox">
        <div class="dis-inline-block closeIcon" @click="hideRulebox"></div>
      </div>
    </div>
    <!-- 补贴金提示弹框 -->
    <div class="redbox-modal money-modal" v-if="isShowMoneybox">
      <div class="money-content">
        恭喜再次获得<span class="money-text">{{ butieMoney }}元</span>购物补贴
      </div>
    </div>
  </div>
</template>

<script>
import redBox from "@/components/redBox.vue";
import timeCountDown from "@/components/timeCountDown.vue";
// import cpsNumScroll from "@/components/numScroll.vue";
import { getNowTime } from "../utils/publicFunc";
import loadMore from "@/components/loadMore.vue";
import countTo from "vue-count-to";
import { getCodeUrl, getUrlCode, getOpenId,getChannelRec } from "@/utils/util";
// 获取设备类型
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
// 如果是IOS设备
if (isiOS) {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };
}
export default {
  components: {
    redBox: redBox,
    timeCountDown: timeCountDown,
    // cpsNumScroll: cpsNumScroll,
    countTo: countTo,
    loadMore: loadMore,
  },
  name: "couponlist",
  data() {
    return {
      isfixShow: false,
      isShowRedbox: false,
      isShowRulebox: false,
      isShowMoneybox: false,
      butieMoney: -1,
      endTime: "",
      baseButie: 0, //记录baseButie
      baseButieScroll: 0, //展示在前端的滚动补贴金
      list: [],
      openId: "",
      page: 1,
      pageSize: 10,
      enableLoadMore: true, // 上拉加载更多
      hasGetMoney: 0,
      isOverdue: false, //是否过期
      needScroll: false, //是否需要数字滚动
      pathId: "", //渠道id
    };
  },
  methods: {
    timeOverHandle() {
      this.needScroll = false;
      this.baseButie = 0;
    },
    openRedbox() {
      console.log("点击了开启红包");
      this.hideRedbox();
    },
    hideRedbox() {
      this.$request(
        {
          url: "getCardMoney",
          data: {
            openid: this.openId,
            timeStamp: new Date().getTime(),
          },
        },
        1111
      )
        .then((res) => {
          _czc.push([
            "_trackEvent",
           "渠道id"+this.pathId+"商品列表页-h5",
            "点击红包【开】按钮"
          ]); //点击红包【开】按钮埋点
          let { money, expire } = res.data;
          this.needScroll = true;
          this.baseButie = money;
          this.endTime = expire * 1000;
          this.isShowRedbox = false;
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
      // this.isShowRedbox = false;
    },
    hideRulebox() {
      this.isShowRulebox = false;
    },
    showRule() {
      this.isShowRulebox = true;
    },
    goJump() {
      window.scrollTo(0, 380);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      // console.log("高度", scrollTop);
      this.isfixShow =
        scrollTop > this.offsetTop + this.offsetHeight - this.fixedOffSetHeight;
    },
    _handelScroll() {
      // handleScroll为页面滚动的监听回调
      window.addEventListener("scroll", this.handleScroll);
      this.$nextTick(() => {
        // 这里fixedHeaderRoot是吸顶元素的ID
        let header = document.getElementById("shopping-benefit-id");
        let headerFix = document.getElementById("fix-shopping-benefit-id");
        // 这里要得到top的距离和元素自身的高度
        this.offsetTop = header.offsetTop;
        this.offsetHeight = header.offsetHeight;
        this.fixedOffSetHeight = headerFix.offsetHeight;
        console.log("offsetTop:" + this.offsetTop + "," + this.offsetHeight);
      });
    },
    showMoney(val = 270, newMoney) {
      _czc.push([
        "_trackEvent",
        "渠道id"+this.pathId+"商品列表页-h5",
        "领取再次获得补贴金"
      ]); //再次获得补贴金埋点
      this.isShowMoneybox = true;
      this.butieMoney = val;
      setTimeout(() => {
        this.isShowMoneybox = false;
        let saveObj = window.localStorage.getItem("saveObj");
        // console.log("saveObj", saveObj);
        if (saveObj) {
          let { scrollTop } = JSON.parse(saveObj);
          console.log("scrollTop ", scrollTop);
          window.scrollTo(0, scrollTop);
          window.localStorage.removeItem("saveObj");
        }
        if (newMoney) {
          setTimeout(() => {
            this.needScroll = true;
            this.baseButie = newMoney;
          }, 1000);
        }
      }, 1000);
    },
    filterList(prolist) {
      //将列表中的goods_id和领取时间记录
      let hasGetObj = window.localStorage.getItem("hasGetObj");
      if (!hasGetObj) return prolist;
      // 判断时间是否为同一天,不是同一天就清空
      let { setTime, list } = JSON.parse(hasGetObj);
      //是同一天
      console.log("同一天");
      let _prolist = prolist.map((v) => {
        if (list.includes(v.id)) {
          v.hasGet = true;
        }
        return v;
      });
      return _prolist;
    },

    getlist(loadMore = null, done = null, newflag = null) {
      let saveObj = window.localStorage.getItem("saveObj");
      if (saveObj) {
        let { list, page } = JSON.parse(saveObj);
        // console.log("list", list, "page", page);
        this.list = list;
        this.page = page + 1;
      }
      console.log("接收到loadMore", loadMore);
      let { page, pageSize, openId } = this;
      let params = {
        page: loadMore ? page + 1 : page,
        page_size: pageSize,
        openid: openId,
      };
      this.page = params.page;
      this.$request({
        url: "listInfo",
        data: params,
      }).then((subRes) => {
        console.log("getlist", subRes);
        let newList = subRes.data.list;
        if (newList && newList.length > 0) {
          newList = newList.map((v, i) => {
            let price = v.coupon_amount / 100 + "";
            let splitPrice = price.split(".");
            if (splitPrice.length == 1) {
              return {
                ...v,
                integer: splitPrice[0],
                decimal: null,
              };
            } else {
              return {
                ...v,
                integer: splitPrice[0],
                decimal: "." + splitPrice[1],
              };
            }
          });

          var more = loadMore ? done() : "";
          let list;
          if (newflag) {
            list = this.list.concat(newList);
          } else {
            list = loadMore ? this.list.concat(newList) : newList;
          }
          this.list = this.filterList(list);
        } else {
          this.page = 1;
          var more = loadMore ? done("没有更多数据") : "";
        }
      });
    },
    loadMore(done) {
      console.log(done);
      let that = this;
      setTimeout(() => {
        if (!that.enableLoadMore) {
          return;
        }
        that.getlist(true, done);
      }, 200);
    },

    goPinDuoDuo(item, index) {
      let { list, baseButie } = this;
     _czc.push ([
        "_trackEvent",
        "渠道id"+this.pathId+"商品列表页-h5",
        "点击商品",
        "商品id"+ item.id,
      ]); //点击商品渠道埋点
      let params = {
        goods_id: item.id,
        openid: this.openId,
        timeStamp: new Date().getTime(),
      };
      if (this.pathId) {
        params = { ...params, channels_id: this.pathId };
      }
      this.$request({
        url: "goodsUrl",
        data: params,
      }).then((res) => {
        console.log("goPinDuoDuo", res);
        if (res.data.code) {
          let { money, expire } = res.data.data;
          this.needScroll = false;
          this.baseButie = money;
          this.endTime = expire * 1000;
          this.$Toast(res.data.msg);
          return;
        }
        let { h5_url } = res.data.url_info;

        if (!list[index].hasGet) {
          this.needScroll = false;
          list[index].hasGet = true; //加上已领取
          //----- 将领取记录保存在本地----
          let hasGetObj = window.localStorage.getItem("hasGetObj");
          if (!hasGetObj) {
            hasGetObj = {
              setTime: new Date().getTime(),
              list: [item.id],
            };
          } else {
            hasGetObj = JSON.parse(hasGetObj);
            hasGetObj = {
              setTime: new Date().getTime(),
              list: [...hasGetObj.list, item.id],
            };
          }
          window.localStorage.setItem("hasGetObj", JSON.stringify(hasGetObj));
          baseButie = res.data.money;
          this.list = list;
          this.baseButie = baseButie;
          window.localStorage.setItem("hasGetMoney", 0);
          console.log("进入hasGetMoney:0");
        } else {
          console.log("进入hasGetMoney:1");
          window.localStorage.setItem("hasGetMoney", 1);
        }

        console.log("跳转成功拼多多h5");
        // 记录当前的的高度
        let saveObj = {
          scrollTop: this.scrollTop,
          page: this.page,
          list: this.list,
        };
        console.log("记录当前的高度", this.scrollTop);
        window.localStorage.setItem("saveObj", JSON.stringify(saveObj));
        _czc.push([
          "_trackEvent",
           "渠道id"+this.pathId+"商品列表页-h5",
          "允许跳转拼多多页面",
          "商品id" + item.id 
        ]); //跳转拼多多埋点
        window.location.href = h5_url;
      });
    },
    getUrlParam(val,name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      let _val = val.split("?")[1]
      if (!_val) {
        return null
      }
      var r = _val.match(reg);//search,查询？后面的参数，并匹配正则
      console.log("_val",_val);
     if(r!=null)return  unescape(r[2]); return null;
    },
    getfirstPar(val,name){
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      let _val = val.split("?")[2]
      if (!_val) {
        return null
      }
      var r = _val.match(reg);//search,查询？后面的参数，并匹配正则
      console.log("_val",_val);
      if(r!=null)return  unescape(r[2]); return null;
    },
    getStatePar(val,name){
     let reg = new RegExp("(^|/)"+ name +"=([^/]*)(/|$)")
     let r = val.match(reg)
      console.log("val",val);
     if(r!=null)return  unescape(r[2]); return null;
    },
    getState(val){
      // let reg =  /(?<=state=).+(?=#)/
      // let r = decodeURIComponent(val).match(reg)
      // console.log("stateR",r);
      // if(r!=null)return  unescape(r[0]); return null;
        var reg = new RegExp("(^|&)"+ "state" +"=([^&]*)(&|$)");
        let r = decodeURIComponent(val).match(reg)
        if(r!=null)return  unescape(r[2].substr(0,r[2].length-12)); return null;
    },
    handlePath(flag){  //处理渠道id的问题
      //--------2.3获取渠道id-------------------
      if (flag) { //无openid/有state
        let _state= this.getState(window.location.href)
        if (_state) {
          this.handlePath()
        }else{  //无openid无state
          this.pathId = this.getUrlParam(window.location.href,"channels_id");
           let tag = this.getUrlParam(window.location.href,"tag")  //判断是否为落地页
           let notFirst = this.getUrlParam(window.location.href,"notFirst")
           if (tag&&!notFirst) {  getChannelRec(this.openId,this.pathId)};
           _czc.push(["_trackEvent", "商品列表页-h5", "进入页面", "渠道id"+this.pathId, this.pathId]);
           console.log("1this.pathId",this.pathId,"tag",tag,"notFirst",notFirst);
        }
      
        return
      }
      //有openid/且有state
      let state= this.getState(window.location.href)
      this.pathId = this.getStatePar(state,"channels_id");
      let tag = this.getStatePar(state,"tag")  //判断是否为落地页
      let notFirst = this.getfirstPar(window.location.href,"notFirst")
      if (tag&&!notFirst) {   getChannelRec(this.openId,this.pathId)};
      _czc.push(["_trackEvent","渠道id"+this.pathId+"商品列表页-h5", "进入页面"]);
      console.log("2this.pathId",this.pathId,"tag",tag,"notFirst",notFirst);
      //---------------------------------------
    },
    getCode() {
      
      let openid = window.localStorage.getItem("openid");
      console.log("openid", openid);
      if (!openid) {
        getUrlCode((res) => {
          console.log("进入回调",res);
          this.openId = res;
          this.handlePath()
          this.getArdMoney();
        });
      } else {
        this.openId = openid;
        this.handlePath(1)
        this.getArdMoney(); //获得补贴金余额,和结束时间后,调用数字滚动和倒计时
      }

   
      //  this.openId =window.localStorage.getItem("openid");
      //  console.log("this.openId",this.openId);
       //this.getArdMoney(); //获得补贴金余额,和结束时间后,调用数字滚动和倒计时
    },
    checkIsOverdue(expire) {
      //判断是否过期
      let saveTargetTime = window.localStorage.getItem("saveTargetTime");
      if (!saveTargetTime) {
        window.localStorage.setItem("saveTargetTime", expire);
      } else {
        if (saveTargetTime != expire) {
          this.isOverdue = true;
          window.localStorage.setItem("saveTargetTime", expire);
        }
      }
    },
    getArdMoney() {
      this.$request(
        {
          url: "cardInfo",
          data: {
            openid: this.openId,
            timeStamp: new Date().getTime(),
            //  clear_cache:getNowTime()
          },
        },
        1111
      )
        .then((res) => {
          let { money, expire } = res.data;
          if (!expire) {
            //未开卡
            this.isShowRedbox = true;
            window.localStorage.removeItem("hasGetObj");
            window.localStorage.removeItem("saveObj");
            this.getlist();
          } else {
            //已开卡
            this.getlist(null, null, true);
            this.baseButie = money;
            this.endTime = expire * 1000;
            let hasGetMoney =
              window.localStorage.getItem("hasGetMoney") || "noGetMoney";
            if (hasGetMoney != "noGetMoney" && hasGetMoney != 1) {
              this.showButieModal();
            }
          }
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    showButieModal() {
      console.log("进入补贴窗口吗?");
      let oldMoney = this.baseButie;
      this.$request({
        url: "getSubsidy",
        data: { openid: this.openId, timeStamp: new Date().getTime() },
      }).then((res) => {
        let newMoney = res.data.money;
        if (oldMoney == newMoney) {
          let saveObj = window.localStorage.getItem("saveObj");
          // console.log("saveObj", saveObj);
          if (saveObj) {
            let { scrollTop } = JSON.parse(saveObj);
            console.log("scrollTop ", scrollTop);
            window.scrollTo(0, scrollTop);
            window.localStorage.removeItem("saveObj");
          }
          return;
        }
        if (newMoney > oldMoney) {
          window.localStorage.removeItem("hasGetMoney");
          this.showMoney(newMoney - oldMoney, newMoney);
        }
      });
    },
  
  },
  
  created() {
    console.log("从create开始进入");
    // this.getCode(); //获取code后换取openId
  },
  mounted() {
    this._handelScroll();
    console.log("从mounted开始进入");
    this.getCode(); //获取code后换取openId
  },
  destroyed() {
    _czc.push([
      "_trackEvent",
       "渠道id"+this.pathId+"商品列表页-h5",
      "离开页面"
    ]);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.couponBuy-container {
  background: #f0edf1;
  position: relative;
  padding-top: 0.2rem;
  .shopping-benefit {
    width: 6.9rem;
    height: 2.85rem;
    background: #e74235;
    border-radius: 0.12rem;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0.36rem 0.2rem 0.3rem 0.3rem;
    .shopping-title-con {
      display: flex;
      align-items: center;
      .shopping-title {
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.45rem;
      }
      .shopping-title-img {
        width: 0.32rem;
        height: 0.32rem;
        margin-left: 0.12rem;
      }
    }
    .shopping-bot {
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      margin-top: 0.57rem;
      .shopping-price-con-bene {
        height: 1.2rem;
        display: flex;
        align-items: baseline;
        .shopping-price {
          font-size: 1.1rem;
          color: #ffffff;
          letter-spacing: 0.022rem;
          line-height: 1.2rem;
        }
        .shopping-unit {
          font-size: 0.36rem;
        }
      }
      .shopping-time-con {
        padding-top: 0.6rem;
        // display: flex;
        font-size: 0.24rem;
        .shopping-time {
          border: 0.02rem solid rgb(255, 255, 255, 0.8);
          border-radius: 0.04rem;
          font-size: 0.24rem;
          line-height: 0.4rem;
          padding: 0 0.04rem;
        }
        .shopping-time-divide {
          margin: 0 0.02rem;
        }
        .shopping-time-span {
          font-size: 0.26rem;
          margin-left: 0.09rem;
        }
      }
    }
  }

  .fix-shopping-benefit {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 0.8rem;
    background: #e74235;
    box-shadow: 0 0.02rem 0.05rem 0 rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.3rem;
    color: #ffffff;
    .fix-price-con {
      display: flex;
      align-items: center;
      .fix-num-span {
        font-size: 0.26rem;
      }

      .fix-num {
        font-size: 0.4rem;
        margin-left: 0.1rem;
      }
    }
    .fix-time-con {
      font-size: 0.28rem;
      display: flex;
      .fix-time {
        font-size: 0.26rem;
        margin-left: 0.08rem;
      }
    }
  }

  .shopping-list {
    box-sizing: border-box;
    overflow: hidden;
    padding: 0.2rem 0.3rem;
    &::after {
      top: 0;
      transform-origin: left top;
    }
    .shopping-item {
      float: left;
      width: 3.35rem;
      height: 5.44rem;
      margin-bottom: 0.2rem;
      background: #fff;
      overflow: hidden;
      border-radius: 0.12rem;

      &:nth-of-type(even) {
        margin-left: 0.2rem;
      }
      .shopping-item-img-con {
        width: 100%;
        // height: 3.1rem;
        height: 3.35rem;
        position: relative;
        background: #f6f6f6;
        overflow: hidden;
        display: flex;
        align-items: center;
        border-radius: 0.12rem 0.12rem 0 0;
        .shopping-img {
          width: 100%;
          // height: 3.35rem;
          display: block;
          // border-radius: 0.12rem 0.12rem 0 0;
          // margin-top: 0.35rem;
          // margin-left: 0.07rem;
          // background-color:yellow ;
          // background-color: #ccc;
        }
        .shopping-rank {
          position: absolute;
          left: 0;
          top: 0;
          width: 0.99rem;
          height: 0.55rem;
          border-radius: 0 1rem 1rem 0;
          // background: linear-gradient(270deg, #FFA329 0%, #FFBD53 100%);
          // background: linear-gradient(270deg, #C3C6C6 0%, #D7D7D7 65%);
          background: linear-gradient(270deg, #e09574 0%, #ebb19b 65%);
          font-size: 0.28rem;
          color: #ffffff;
          line-height: 0.55rem;
          text-align: center;
        }
        .bg1 {
          background: linear-gradient(270deg, #ffa329 0%, #ffbd53 100%);
        }
        .bg2 {
          background: linear-gradient(270deg, #c3c6c6 0%, #d7d7d7 65%);
        }
        .shopping-have-get {
          position: absolute;
          right: 0;
          top: 0;
          width: 0.98rem;
          height: 0.98rem;
        }
      }

      .shopping-item-span-con {
        padding: 0.24rem 0.2rem 0.3rem;

        .shopping-span {
          font-size: 0.24rem;
          color: #333333;
          line-height: 0.34rem;
          overflow: hidden;
          text-overflow: ellipsis;
          // max-height: 1.00rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          word-wrap: break-word;
          .shopping-brand {
            border: 0.02rem solid #e74235;
            border-radius: 0.05rem;
            padding: 0 0.04rem;
            font-size: 0.2rem;
            color: #e74235;
            // line-height: 0.28rem;
            margin-right: 0.1rem;
            // display: inline-block;
            // width: 0.72rem;
            // height: 0.30rem;
            // text-align: center;
            // line-height: 0.30rem;
          }
          // .shopping-item-span{
          //     font-size: .24rem;
          //     color: #333333;
          //     line-height: .34rem;
          //     overflow: hidden;
          //     text-overflow: ellipsis;
          //     // max-height: 1.00rem;
          //     display: -webkit-box;
          //     -webkit-box-orient: vertical;
          //     -webkit-line-clamp:2;
          //     word-break: break-all;
          //     word-wrap: break-word;
          // }
        }

        .shopping-price-con {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-top: 0.06rem;
          .price-con1 {
            font-size: 0.24rem;
            color: #e74235;
            // line-height: 0.28rem;
            line-height: 0.4rem;
            .price-con2 {
              font-size: 0.28rem;
              margin: 0 0.04rem;
            }
            .price-con3 {
              font-size: 0.5rem;
              // line-height: 0.48rem;
            }
            .price-con-mini {
              font-size: 0.3rem;
            }
          }

          .price-con4 {
            font-size: 0.22rem;
            color: #999999;
            line-height: 0.3rem;
            text-decoration: line-through;
          }
        }

        .shopping-butie-con {
          display: flex;
          margin-top: 0.12rem;
          .zhekou-con {
            width: 0.9rem;
            height: 0.34rem;
            position: relative;
            margin-right: 0.1rem;
            .zhekou-span {
              position: relative;
              width: 100%;
              height: 100%;
              text-align: center;
              font-size: 0.24rem;
              color: #ffffff;
              line-height: 0.34rem;
              z-index: 1;
            }
            .zhekou-img {
              position: absolute;
              left: 0;
              top: 0;
              width: 0.9rem;
              height: 0.34rem;
            }
          }
          .butiejin {
            width: 1.55rem;
            height: 0.34rem;
            background: #e74235;
            border-radius: 0.04rem;
            text-align: center;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #ffffff;
          }
        }
      }
    }
  }
}

.isoverflow {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.redbox-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;
  box-sizing: border-box;
  // padding-top: 2.71rem;
  // padding-top: 1.84rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /deep/.noReceive {
    text-align: center;
  }

  /deep/.red-bottom {
    & > div {
      text-align: center;
    }
  }
  /deep/.one-row {
    text-align: center;
  }
  /deep/.two-row {
    text-align: center;
  }
  .closeBox {
    margin-top: 0.3rem;
    .closeIcon {
      height: 0.5rem;
      width: 0.5rem;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURf///////////////////////////0dwTP///////////////////////////////////////////////////////////5qHap4AAAAXdFJOU5mUDwSOCHAAhxOEP0c2W1QKK3ZDIGIaP3c9IAAAAkFJREFUSA2dVteigyAMDQ5Q3KP+/6feEzba2l59aBk5JDkZQOryzcModSWo0nIc5su2otNS20lBySdk155Eckg7Ommh5ao9dsxBKWSejNDaH7U9uD76lc8QU2pfAlkq7DZdkdtRdA2WqyWuRkjPO1sZt/yo3Pis3k+D++ULy6MzKOy6wTxh8+VPc1pq2CyGs2icD8CsDuMg0FHtUeI62mHcyy5bCPxociYvoBYsWH8MZIHaWx18wA4hwxtDZoTjxg+vEP6IGROGgI/Jr9/9OzlACmQgo79+c0UCHgMCtrYgvmzn6G8x8BtCx5BWUOOjpEBETh2IEgFTgrUWEEC7oISzJsUwtYkNHcuSkkTRlplFIsYgmrhdEElFYHgNSpSyQi6s2cQIreCZwHZMUiwnYsnQHwrDB0IdHn7B/AfBMEi2D3BGcOWU8k70HULVcIY0ieSURE9OhJcRAFSk/TT8GwUZdWGLAQK0XT6LiWRHAQkAqi0u+NFnCFh+YtgD9x+Q/CCUDxLmQVrmyc9FdEn+mFA2+fMS486TRtAEKFSlciXWEulQyKUmnfVAYJrQS3whK3AW20W5B7hNhXqJRYmaR5NFh0G/+L0pAQ/Ig9an0NJ+bLDGGtbC3Ut8b+PIesOdgZToAlVGlHU9/WW6e0ONgZgm29zquVxJqvx28cGq1WWB06Jqvl6z6z2x6u31in1ux/+6xIEZwPX/ngq4AG8eJEkaeV+s5QV7xJ/Qq/zl2cOwYjs/rrZzwHItRpd7wolPT7g/0lVANp//rhwAAAAASUVORK5CYII=");
    }
  }
}

.rulebox-modal {
  .rulebox {
    width: 5.9rem;
    height: 6.51rem;
    background: #ffffff;
    border-radius: 0.24rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-bottom: 48rpx;

    .rulebox-title {
      font-size: 0.32rem;
      color: #333333;
      letter-spacing: 0.03px;
      line-height: 0.45rem;
      margin: 0.4rem 0 0.22rem;
    }
    .rulebox-content {
      margin-bottom: 0.4rem;
      padding: 0 0.52rem;
      .rulebox-content-1 {
        font-size: 0.26rem;
        line-height: 0.38rem;
        color: #606060;
        letter-spacing: 0.04px;
        margin-bottom: 0.2rem;
      }
    }
    .rulebox-btn {
      width: 4.2rem;
      height: 0.8rem;
    }
  }
}

.money-modal {
  // padding-top: 4.9rem;
  .money-content {
    width: 5.4rem;
    height: 1.28rem;
    text-align: center;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0 auto;
    font-size: 0.3rem;
    font-weight: bold;
    color: #333;
    line-height: 1.28rem;
    .money-text {
      color: #ff4949;
    }
  }
}
</style>